import React from 'react'
import { Well } from '@pushly/aqe/lib/components'
import { Loading3QuartersOutlined } from '@ant-design/icons'
// Use shared OccurrenceList extracted from journeys
import { OccurrenceList } from './occurrence-list'

import { OccurrenceDTO } from '../types'

export interface INextOccurrencesPreviewProps {
  occurrences: OccurrenceDTO[]
  tz: string
  loading?: boolean
  maxCount?: number
  title?: string
  emptyMessage?: string
}

export const NextOccurrencesPreview: React.FC<INextOccurrencesPreviewProps> = React.memo(
  ({
    occurrences,
    tz,
    loading = false,
    maxCount = 7,
    title,
    emptyMessage = 'No dates found for current schedule',
  }) => {
    const safeOccurrences = Array.isArray(occurrences) ? occurrences : []
    const count = safeOccurrences.length === 0 || safeOccurrences.length >= maxCount ? maxCount : safeOccurrences.length
    const computedTitle = title ?? `Next ${count} Occurrences`

    return (
      <div className="recurrence-schedule-preview">
        <Well mode="ghost" title={computedTitle} hideFooter={true}>
          <div className="recurrence-schedule-preview-content">
            {loading ? (
              <span className="loading-indicator">
                <Loading3QuartersOutlined spin={true} />
                <span>Loading</span>
              </span>
            ) : safeOccurrences.length === 0 ? (
              emptyMessage
            ) : (
              <OccurrenceList occurrences={safeOccurrences as any[]} tz={tz} />
            )}
          </div>
        </Well>
      </div>
    )
  },
)
